// extracted by mini-css-extract-plugin
export default {"main":"ActionsPanel_main__PlbXW","icon":"ActionsPanel_icon__fpOZU","arrow":"ActionsPanel_arrow__Iwt9-"};